<script setup lang="ts">
import type { AccordionItem } from '@nuxt/ui'

const { model } = defineProps({
  model: Object,
})

const items = computed<AccordionItem[]>(() => {
  return (model?.accordionItems?.expandedValue || []).map((item: any) => ({
    label: item?.title?.value || '',
    content: item?.body?.value || '',
  }))
})
</script>

<template>
  <!-- Accordion Block -->
  <div
    class="block-spacing max-w-177.5 mx-auto accordion-block"
  >
    <div class="prose mb-5 lg:mb-7.5">
      <h2 v-if="model?.title?.value">
        {{ model.title.value }}
      </h2>
      <p
        v-if="model?.body?.value"
        v-html="model?.body?.value"
      />
    </div>
    <UAccordion
      type="multiple"
      :items="items"
      class=""
    >
      <template #body="{ item }">
        <div
          class="accordion-body"
          v-html="item.content"
        />
      </template>
    </UAccordion>
  </div>
</template>

<style lang="scss">
.page-block-area {
  .accordion-block {
    @media (min-width: 1280px) {
      display: flex;
      gap: 30px;
      align-items: flex-start;
      max-width: 1210px;

      .prose {
        width: 66.666%;
      }
    }
  }
}

.accordion-body {
  > * {
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
